/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CheckAudioChannelResult} from "../model/check-audio-channel-result";
import {DeleteAudioChannelReferenceFromTrainingRoomRequest} from "../model/delete-audio-channel-reference-from-training-room-request";
import {DeleteLibraryReferenceFromScenarioRequest} from "../model/delete-library-reference-from-scenario-request";
import {DeleteMediaFromLibraryRequest} from "../model/delete-media-from-library-request";
import {InvalidScenario} from "../model/invalid-scenario";
import {InvalidTrainingRoomToAudioChannelMappingResponse} from "../model/invalid-training-room-to-audio-channel-mapping-response";
import {ListData} from "../model/list-data";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimSupportService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteAudioChannelReferenceFromTrainingRoom(request: DeleteAudioChannelReferenceFromTrainingRoomRequest) {
        return super.post<SuccessResponse>(`/api/Support/DeleteAudioChannelReferenceFromTrainingRoom`, request);
    }

    public deleteLibraryReferenceFromScenario(request: DeleteLibraryReferenceFromScenarioRequest) {
        return super.post<SuccessResponse>(`/api/Support/DeleteLibraryReferenceFromScenario`, request);
    }

    public deleteMediaFromLibrary(request: DeleteMediaFromLibraryRequest) {
        return super.post<SuccessResponse>(`/api/Support/DeleteMediaFromLibrary`, request);
    }

    public fixInvalidScenario(invalidScenario: InvalidScenario) {
        return super.post<SuccessResponse>(`/api/Support/FixInvalidScenario`, invalidScenario);
    }

    public fixInvalidTrainingRoom(invalidTrainingRoom: InvalidTrainingRoomToAudioChannelMappingResponse) {
        return super.post<SuccessResponse>(`/api/Support/FixInvalidTrainingRoom`, invalidTrainingRoom);
    }

    public fixMissingCamerasInTrainingRoomLayout() {
        return super.get<SuccessResponse>(`/api/Support/FixMissingCamerasInTrainingRoomLayout`, );
    }

    public getAllInvalidScenarios() {
        return super.get<ListData<InvalidScenario>>(`/api/Support/GetAllInvalidScenarios`, );
    }

    public getAllInvalidTrainingRoomAudioChannelMappings() {
        return super.get<ListData<InvalidTrainingRoomToAudioChannelMappingResponse>>(`/api/Support/GetAllInvalidTrainingRoomAudioChannelMappings`, );
    }

    public getInvalidAudioChannels() {
        return super.get<CheckAudioChannelResult[]>(`/api/Support/GetInvalidAudioChannels`, );
    }
}